// import node module libraries
import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import { Col, Card, Button, Offcanvas, Dropdown, Image, Row, Form, Modal, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap';
import { ChevronLeft, ChevronRight, MoreVertical, Trash, Edit, Mail } from 'react-feather';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

// import media files
import Avatar from 'assets/images/avatar/avatar.jpg';

// import custom components
import DotBadge from 'components/elements/bootstrap/DotBadge';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

// import notification component
import Notification, { handleShowNotification } from 'components/elements/notification/Notification';

// Import the new components
import OffcanvasEditUser from './OffcanvasEditUser';
import ModalDeleteUser from './ModalDeleteUser';

function UsersGridViewSettings({ activeKey }) {
	const { t } = useTranslation();
	const [notification, setNotification] = useState({ variant: '', title: '', message: '' });
	const [isLoading, setIsLoading] = useState(null); // State for loading table

	// Edit User Role
	const handleChangeEditUserRole = (userId, e) => {
		const updatedUsersList = usersList.map(user => {
			if (user.id === userId) {
				const updatedUser = {
					...user,
					role_id: e.target.checked ? "a237047f-cdd6-11ef-8d7a-0242ac120009" : "f65b80f5-cf5d-11ef-8d7a-0242ac120009"
				};
				//console.log(updatedUser);
				const data = {
					user_first_name: updatedUser.user_first_name,
					user_last_name: updatedUser.user_last_name,
					user_username: updatedUser.user_username,
					role_id: updatedUser.role_id,
					user_avatar: updatedUser.user_avatar,
				};
				console.log(updatedUser);

				// Dynamische URL basierend auf der Umgebung
				const baseURL = process.env.REACT_APP_ENV === 'development'
					? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
					: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

				axios.patch(`${baseURL}/users/${updatedUser.id}`, data, options)
					.then(response => {
						handleShowNotification(setNotification, 'success', 'Erfolgreich', t(response.data.message));
					})
					.catch((error) => {
						const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
						handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte überprüfe deine eingegebenen Daten oder kontaktiere den HelpDesk.');
					});

				return updatedUser;
			}
			
			return user;
		});
		setUsersList(updatedUsersList);

		
	};

	// paging start
	const [paginationData, setPaginationData] = useState([]); // State for pagination data
	const [pageNumber, setPageNumber] = useState(1);
	const usersPerPage = 30;
	const pageCount = paginationData.total_pages;
	const changePage = ({ selected }) => {
		const newPage = selected + 1; //pages starts with 1
		setPageNumber(newPage);
		getData(newPage);
	};
	// paging end

	const auth = useAuthUser(); // Assuming this gets the auth user data

	// Form Data Users
	const [formDataUser, setFormDataUser] = useState([]); // State for form data
	const [dataUsers, setDataUsers] = useState({ data: [] }); // State for response data
	const [usersList, setUsersList] = useState([]); // State for response data

	// API-Call Options
	const authHeader = useAuthHeader();
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	// API-Call for all Data
	const getData = async (page) => {
		if (!page) {
			page = 1;
		}
		setIsLoading(true);
		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		// Tenant Data
		await axios.get(`${baseURL}/users?limit=${usersPerPage}&page=${page}`, options)
			.then(response => {
				const responseData = response.data.data; // Extract the data from the response
				setDataUsers({ data: responseData });
				setUsersList(responseData);
				setPaginationData(response.data.pagination);
				setIsLoading(false);
			})
			.catch((error) => {
				setIsLoading(false);
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');
			});
	};

	useEffect(() => {
		if (activeKey === 'users') {
			getData();
		}
	}, [activeKey]);

	// Delete User
	const [showDeleteModal, setShowDeleteModal] = useState(false); // State for showing modal
	const [isLoadingButtonUserDelete, setIsLoadingButtonUserDelete] = useState(null); // State for loading spinner
	const [userToDelete, setUserToDelete] = useState(null); // State for user to delete
	
	const handleDeleteClick = (user) => {
		setUserToDelete(user);
		setShowDeleteModal(true);
	};

	const handleConfirmDelete = async () => {
		if (userToDelete) {
			setIsLoadingButtonUserDelete(true);
			const baseURL = process.env.REACT_APP_ENV === 'development'
				? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
				: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

			await axios.delete(`${baseURL}/users/${userToDelete.id}`, options)
				.then(response => {
					setUsersList(usersList.filter(user => user.id !== userToDelete.id));
					setShowDeleteModal(false);
					setIsLoadingButtonUserDelete(false);
					handleShowNotification(setNotification, 'success', 'Erfolgreich', 'Der Benutzer wurde erfolgreich gelöscht');
				})
				.catch((error) => {
					setIsLoadingButtonUserDelete(false);
					const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
					handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');
				});
		}
	};

	// Edit User

	const [showEditUserOffcanvas, setShowEditUserOffcanvas] = useState(false); // State for showing offcanvas
	const [isLoadingButtonUserEdit, setIsLoadingButtonUserEdit] = useState(null); // State for loading spinner
	const [userToEdit, setUserToEdit] = useState(null); // State for user to edit

	const handleShowEditUser = () => setShowEditUserOffcanvas(true); // Show offcanvas
	const handleCloseEditUser = () => setShowEditUserOffcanvas(false); // Close offcanvas

	const handleEditUser = async (e) => {
		e.preventDefault();

		//setIsButtonDisabled(true);
		setIsLoadingButtonUserEdit(true); // Set loading to true

		const data = {
			user_first_name: e.target.firstname.value,
			user_last_name: e.target.lastname.value,
			user_username: e.target.username.value,
			role_id: userToEdit.role_id,
			user_avatar: null, // not implemented yet
		};

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		axios.patch(`${baseURL}/users/${userToEdit.id}`, data, options)
			.then(response => {
				handleShowNotification(setNotification, 'success', 'Erfolgreich', t(response.data.message));
				setIsLoadingButtonUserEdit(false); // Stop loading
				handleCloseEditUser();
				setUsersList(usersList.map(user => user.id === userToEdit.id ? { ...user, ...data, role_id: userToEdit.role_id } : user));
			})
			.catch((error) => {
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte überprüfe deine eingegebenen Daten oder kontaktiere den HelpDesk.');
				setIsLoadingButtonUserEdit(false); // Stop loading
			});
	};

	// Send Activation Link to User
	const [isButtonDisabled, setIsButtonDisabled] = useState(false);
	
	const handleSendActivationLink = async (e) => {
		console.log('ausgelöst');
		setIsButtonDisabled(true);
		//setIsLoading(true); // Set loading to true

		// Get username from data-attribute
		const username = e.currentTarget.getAttribute('data-username');

		// API-Call Options
		const options = {
			params: {
			},
			headers: {
				Authorization: authHeader,
				Accept: 'application/json'
			}
		};
		const data = {
			username: username,
			otp_valid_for: "activate_account"
		}

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		axios.post(`${baseURL}/auth/generate-otp`, data, options)
			.then(response => {
				setIsButtonDisabled(false);
				//setIsLoading(false); // Stop loading
				handleShowNotification(setNotification, 'info', 'Information', response.data.message + '. Eine Aktivierungs E-Mail wurde an den Benutzer übermittelt.');

			})
			.catch((error) => {
				setIsButtonDisabled(false);
				//setIsLoading(false); // Stop loading
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Es konnte keine Aktivierungs E-Mail zum Benutzer gesendet werden. Bitte versuche es später erneut oder kontaktiere den Support über hello@haeppy-shopping.com.');
			})
	};

	const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
		<Link
			to=""
			ref={ref}
			onClick={(e) => {
				e.preventDefault();
				onClick(e);
			}}
			className="btn-icon btn btn-ghost btn-sm rounded-circle"
		>
			{children}
		</Link>
	));

	// Component Status-Badge
	const statusBadge = (value) => {
		return (
			<Fragment>
				<DotBadge
					bg={
						value === 'inactive'
							? 'warning'
							: value === 'active'
								? 'success'
									: value === 'blocked'
										? 'danger'
										: 'info'
					}
				></DotBadge>
				{
					value === 'active'
						? t('Active')
						: value === 'inactive'
							? t('Not verified')
							: value === 'blocked'
								? t('Blocked')
								: 'Unbekannt'
				}
			</Fragment>
		);
	}

	// searching code started
	const [searchTerm, setSearchTerm] = useState('');

	const getSearchTerm = (event) => {
		let searchTerm = event.target.value;
		setSearchTerm(searchTerm);
		if (searchTerm !== '') {
			const newUsersList = dataUsers.data.filter((user) => {
				return Object.values(user)
					.join(' ')
					.toLowerCase()
					.includes(searchTerm.toLowerCase());
			});
			setUsersList(newUsersList.slice(0, 500));
			//setPageNumber(1);
		} else {
			setUsersList(dataUsers.data.slice(0, 500));
		}
	};

	return (
		<Fragment>
			{notification.show && (
				<Notification variant={notification.variant} title={notification.title} message={notification.message} show={notification.show} setNotification={setNotification} />
			)}
			<div className="mb-4">
				<Form.Control
					type="search"
					placeholder={t('Search users')}
					value={searchTerm}
					onChange={getSearchTerm}
				/>
			</div>
			<Row>
				{isLoading ? (
					<div className="d-flex justify-content-center">
						<Spinner animation="border" role="status">
							<span className="visually-hidden">Loading...</span>
						</Spinner>
					</div>
				) : usersList.length > 0 ? (
					usersList.map((users) => (
						<Col xxl={4} xl={6} lg={6} md={12} sm={12} key={users.id}>
							<Card className="mb-5">
								<div className="d-flex justify-content-end my-1 mx-1">
									<Dropdown>
										<Dropdown.Toggle as={CustomToggle}>
											<MoreVertical size="15px" className="text-secondary" />
										</Dropdown.Toggle>
										<Dropdown.Menu align="end">
											<Dropdown.Header>{t('SETTINGS')}</Dropdown.Header>
											<Dropdown.Item eventKey="1" onClick={() => { handleShowEditUser(); setUserToEdit(users); }}>
												{' '}
												<Edit size="15px" className="dropdown-item-icon" /> {t('Edit')}
											</Dropdown.Item>
											{users.user_username === auth.username ? (
												<OverlayTrigger
													placement="bottom"
													overlay={<Tooltip id={`tooltip-bottom`}>{t('You cannot delete yourself. Please ask another Company Administrator to delete you or contact the HelpDesk.')}</Tooltip>}
												>
													<span className="d-inline-block">
														<Dropdown.Item eventKey="2" disabled style={{ pointerEvents: 'none' }}>
															{' '}
															<Trash size="15px" className="dropdown-item-icon" /> {t('Delete')}
														</Dropdown.Item>
													</span>
												</OverlayTrigger>
											) : (
												<Dropdown.Item eventKey="2" onClick={() => handleDeleteClick(users)}>
													{' '}
													<Trash size="15px" className="dropdown-item-icon" /> {t('Delete')}
												</Dropdown.Item>
											)}
										</Dropdown.Menu>
									</Dropdown>
								</div>
								<Card.Body>
									<div className="text-center">
										<Image
											src={users.user_avatar || Avatar}
											className="rounded-circle avatar-xl mb-3"
											alt=""
										/>
										<h4 className="mb-0">{users.user_first_name}{' '}{users.user_last_name}</h4>
										<p className="mb-0">{users.user_username}</p>
									</div>
									<div className="d-flex justify-content-between border-bottom py-2 mt-4">
										<span>{t('Company Administrator')}</span>
										<Form>
											<Form.Group controlId={users.id} className="d-none">
												<Form.Label visuallyHidden>ID</Form.Label>
												<Form.Control type="text" value={users.id} disabled required />
											</Form.Group>
											<Form.Check
												type="checkbox"
												label=""
												className="form-switch"
												defaultChecked={users && users.role_id === "a237047f-cdd6-11ef-8d7a-0242ac120009"}
												onChange={(e) => handleChangeEditUserRole(users.id, e)}
												disabled={users.user_username === auth.username}
											/>
										</Form>
									</div>
									<div className="d-flex justify-content-between py-2">
										<span>{t('Status')}</span>
										<span className={users.user_is_active === 1 ? 'text-success' : 'text-warning'}>
											{users.user_is_active === 1 ? statusBadge('active') : (
												<Fragment>
													<>
														{statusBadge('inactive')}
													</>
													<span className="ms-2">
														<OverlayTrigger
															key="top"
															placement="top"
															overlay={<Tooltip id={`tooltip-top`}>{t('Send activation link')}</Tooltip>}
														>
															<Link onClick={handleSendActivationLink} data-username={users.user_username} className="text-decoration-none" disabled={isButtonDisabled}>
																<Mail size="15px" className="dropdown-item-icon" />
															</Link>
														</OverlayTrigger>
													</span>
												</Fragment>
											)}
										</span>
									</div>
								</Card.Body>
							</Card>
						</Col>
					))
				) : (
					<Col>{t('No users found')}.</Col>
				)}
			</Row>

			<ReactPaginate
				previousLabel={<ChevronLeft size="14px" />}
				nextLabel={<ChevronRight size="14px" />}
				pageCount={pageCount}
				onPageChange={changePage}
				isPrevious={paginationData.prev_page}
				isNext={paginationData.next_page}
				containerClassName={'justify-content-center mb-0 pagination'}
				previousLinkClassName={'page-link mx-1 rounded'}
				nextLinkClassName={'page-link mx-1 rounded'}
				pageClassName={'page-item'}
				pageLinkClassName={'page-link mx-1 rounded'}
				disabledClassName={'paginationDisabled'}
				activeClassName={'active'}
			/>

			{/* Edit User Offcanvas */}
			<OffcanvasEditUser
				show={showEditUserOffcanvas}
				onHide={handleCloseEditUser}
				userToEdit={userToEdit}
				handleEditUser={handleEditUser}
				isLoadingButtonUserEdit={isLoadingButtonUserEdit}
				auth={auth}
			/>

			{/* Delete User Modal */}
			<ModalDeleteUser
				show={showDeleteModal}
				onHide={() => setShowDeleteModal(false)}
				handleConfirmDelete={handleConfirmDelete}
				isLoadingButton={isLoadingButtonUserDelete}
			/>
		</Fragment>
	);
}

export default UsersGridViewSettings;
